import { Select, SelectProps, getVariant } from '@apia/theme';

export const ToolbarSelect = (props: SelectProps) => {
  return (
    <Select
      {...props}
      className={`toolbar__select ${props?.className ?? ''}`}
      {...(props.variant ? getVariant(props.variant) : null)}
    >
      {props.children}
    </Select>
  );
};
